<template>
  <div class="HotCountryFix">
    <div style="padding: 3px">
      <p :style="{ fontSize: fontSize.p + 'em' }">熱搜國家</p>
    </div>
    <hr />
    <div class="country">
      <div
        class="c_Circle"
        v-for="(country, countryId) in popularList"
        :key="countryId"
      >
        <router-link
          class="flag_wrap"
          :to="`/${country.countryId}`"
          :title="country.country"
        >
          <img :src="country.flagFile" :alt="country.country" />
        </router-link>
        <router-link
          class="conuntry_name"
          :to="`/${country.countryId}`"
          :style="{ fontSize: fontSize.p + 'em' }"
          :title="country.country"
        >
          {{ country.country }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { inject } from "vue";
import { reactive } from "@vue/reactivity";
import { apiPopularCountry } from "@/api/api.js";

export default {
  name: "HotCountryFix",
  setup() {
    const popularList = reactive([]);
    let fontSize = inject("fontSize");
    apiPopularCountry()
      .then(function (res) {
        res.data.forEach((i) => {
          popularList.push(i);
        });
      })
      .catch((err) => {
        console.log(err);
      });
    return {
      popularList,
      fontSize,
    };
  },
};
</script>

<style lang="scss" scoped>
.HotCountryFix {
  display: flex;
  flex-direction: column;
  width: 100px;
  background-color: rgba(255, 255, 255, 0.747);
  padding: 2px;
  border-radius: 5px;
  hr {
    border: 2px solid $main_sec_color;
    margin: 10px 0;
  }
  .country {
    .c_Circle {
      border-radius: 50%;
      width: 80px;
      height: 80px;
      margin: 0 auto;
      transform: translateY(-15px);
      transition: 0.25s;
      &:hover .conuntry_name {
        text-decoration: underline;
      }
      &:hover .flag_wrap {
        width: 90%;
        transition: 0.25s;
      }
      .flag_wrap {
        transform: translateY(17px);
        width: 83%;
        border: 1px solid #ccc;
        opacity: 0.85;
      }
    }
    div {
      padding: 5px;
    }
  }
  .conuntry_name {
    transform: translateY(17px);
  }
}
</style>
